import type { IContextDocumentIngestionStatus, IContextDocumentType } from '@/lib/constants/contextDocuments'

const DOCUMENT_TYPES: Record<IContextDocumentType, string> = {
  policy: 'Policy',
  procedure: 'Procedure',
  register: 'Register',
  document: 'Document',
}

const AGENT_STATUS: Record<IContextDocumentIngestionStatus, string> = {
  pending: 'Processing',
  indexed: 'Available to the agent',
  failed: "Couldn't be processed",
}

export const CONTEXT_DOCUMENTS = {
  TITLE: 'Additional context',
  UPLOAD_BUTTON: 'Upload file',
  SEARCH_PLACEHOLDER: 'Search by name',
  EMPTY: 'No files yet',
  NO_RESULTS: 'No files match the filters',
  STALE: 'Over 12 months',
  INGESTION_TIMEOUT: 'Processing took too long. Replace the file to try again',
  INGESTION_ERROR: "The file couldn't be sent to the agent. Try again or replace the file.",
  DOCUMENT_TYPES,
  AGENT_STATUS,
  COLUMNS: {
    NAME: 'Name',
    TYPE: 'Type',
    VISIBILITY: 'Visibility',
    OWNER: 'Owner',
    LAST_REVIEW: 'Last review',
    UPLOADED: 'Uploaded',
    AGENT_STATUS: 'Agent status',
    ACTIONS: 'Actions',
  },
  ACTIONS: {
    DOWNLOAD: 'Download',
    EDIT: 'Edit details',
    MARK_REVIEWED: 'Mark as reviewed',
    REPLACE: 'Replace file',
    DELETE: 'Delete',
    MORE: 'More actions',
  },
  DIALOG: {
    UPLOAD_TITLE: 'Upload file',
    EDIT_TITLE: 'Edit details',
    UPLOAD: 'Upload',
    UPLOADING: 'Uploading...',
    SAVE: 'Save',
    SAVING: 'Saving...',
    NAME: 'Name',
    DESCRIPTION: 'Description',
    DESCRIPTION_PLACEHOLDER: 'What does this file prove?',
    TYPE: 'Type',
    VISIBILITY: 'Visibility',
    OWNER: 'Owner',
    LAST_REVIEW: 'Last review',
    SELECT_TYPE: 'Select a type',
    SELECT_VISIBILITY: 'Select a visibility',
    SELECT_OWNER: 'Select an owner',
    FILE_TYPE_HINT: 'PDF, Word, Excel, CSV, TXT, Markdown or HTML',
  },
  REPLACE_DIALOG: {
    TITLE: 'Replace file',
    DESCRIPTION_PREFIX: 'Replace the file of',
    DESCRIPTION_SUFFIX: 'The previous version will be lost and the agent will read the new one.',
    CONFIRM: 'Replace',
  },
  DELETE_DIALOG: {
    TITLE: 'Delete file',
    DESCRIPTION_PREFIX: 'Delete',
    DESCRIPTION_SUFFIX: 'The agent will no longer use it.',
  },
  MESSAGES: {
    UPLOADED: 'File uploaded',
    UPDATED: 'Details saved',
    REVIEWED: 'Marked as reviewed',
    REPLACED: 'File replaced',
    DELETED: 'File deleted',
  },
  ERRORS: {
    NOT_FOUND: 'This file no longer exists. Reload the page.',
    FILE_MISSING: "This file's content is no longer available. Replace the file to restore it.",
    INVALID_OWNER: "The selected owner can't own these files. Choose another owner.",
    INVALID_FIELDS: 'Some details are missing or invalid. Review them and try again.',
    INVALID_ID: "This file link isn't valid.",
    FORBIDDEN: "You don't have permission to do this.",
    GENERIC: 'Something went wrong. Try again.',
  },
}
